import React, { useState, useEffect, useRef } from "react";
import { Divider } from "antd";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import FormNumber from "../../../components/common/FormNumber/FormNumber";
import Title from "../../../components/common/Title/Title";
import Description from "./components/Description";
import { Button } from "react-bootstrap";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import Cookies from "js-cookie";
import SwalToast from "../../../components/helpers/SwalToast";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";
import httpclient from "../../../components/httpclient";

export default function MembershipSetting() {
  const [data, setData] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}customer-membership/settings`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        let res = response.data.data;
        for (var prop in res) {
          if (Object.prototype.hasOwnProperty.call(res, prop)) {
            setData((prev) => ({
              ...prev,
              [prop]: parseFloat(res[prop]),
            }));
          }
        }
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleChange =
    (field = "") =>
      (event) => {
        const { floatValue } = event;
        setData((prev) => ({
          ...prev,
          [field]: floatValue == undefined ? null : parseFloat(floatValue),
        }));
      };

  const validate = () => {
    const newErrors = {};

    if (!data.referral_code_duration_in_x_days) {
      newErrors.referral_code_duration_in_x_days = true;
    }
    if (!data.minimum_amount_of_gadai_infinite_in_rupiah) {
      newErrors.minimum_amount_of_gadai_infinite_in_rupiah = true;
    }
    if (!data.customer_infinite_duration_in_x_days) {
      newErrors.customer_infinite_duration_in_x_days = true;
    }
    if (!data.referral_code_commission_in_percent) {
      newErrors.referral_code_commission_in_percent = true;
    }
    if (!data.referral_code_zero_capital_commission_value_in_percent) {
      newErrors.referral_code_zero_capital_commission_value_in_percent = true;
    }

    if (!data.referral_code_zero_capital_commission_max_in_rupiah) {
      newErrors.referral_code_zero_capital_commission_max_in_rupiah = true;
    }
    if (!data.referral_code_extension_commission_in_percent) {
      newErrors.referral_code_extension_commission_in_percent = true;
    }
    if (
      !data.referral_code_extension_zero_capital_commission_value_in_percent
    ) {
      newErrors.referral_code_extension_zero_capital_commission_value_in_percent = true;
    }
    if (!data.referral_code_extension_zero_capital_commission_max_in_rupiah) {
      newErrors.referral_code_extension_zero_capital_commission_max_in_rupiah = true;
    }
    if (!data.agent_commission_in_percent) {
      newErrors.agent_commission_in_percent = true;
    }

    if (!data.agent_zero_capital_commission_value_in_percent) {
      newErrors.agent_zero_capital_commission_value_in_percent = true;
    }
    if (!data.agent_zero_capital_commission_max_in_rupiah) {
      newErrors.agent_zero_capital_commission_max_in_rupiah = true;
    }
    if (!data.agent_extension_commission_in_percent) {
      newErrors.agent_extension_commission_in_percent = true;
    }
    if (!data.agent_extension_zero_capital_commission_value_in_percent) {
      newErrors.agent_extension_zero_capital_commission_value_in_percent = true;
    }
    if (!data.agent_extension_zero_capital_commission_max_in_rupiah) {
      newErrors.agent_extension_zero_capital_commission_max_in_rupiah = true;
    }
    return newErrors;
  };

  const onSubmit = () => {
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      setSubmitting(true);
      console.log(data);
      let url = `${process.env.REACT_APP_BASE_API_URL}customer-membership/settings`;
      httpclient
        .POST(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          getData();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  return (
    <div className="pb-4">
      <div className="px-3">
        <div className="py-4">
          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Pengaturan Membership"} />
            <Breadcrumb current={"Pengaturan Membership"} />
          </div>
        </div>

        <div>
          <div className="d-flex mt-3">
            <div style={styles.container}>
              <div style={styles.title}>Waktu Terhubung dengan Referral</div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    id="referral_code_duration_in_x_days"
                    style={styles.formNumber}
                    suffix="Hari"
                    value={data.referral_code_duration_in_x_days}
                    onValueChange={handleChange(
                      "referral_code_duration_in_x_days"
                    )}
                    error={errors.referral_code_duration_in_x_days}
                  />
                </div>
                <Description text="Pemilik referral yang digunakan akan menerima komisi dari transaksi selama x hari" />
              </div>
            </div>
            <div style={{ flex: 0.2 }} />
            <div style={{ flex: 5, padding: 12 }}></div>
          </div>
          <div className="d-flex mt-3">
            <div style={styles.container}>
              <div style={styles.title}>Minimal Transaksi Gadai Infinite</div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="Rupiah"
                    value={data.minimum_amount_of_gadai_infinite_in_rupiah}
                    onValueChange={handleChange(
                      "minimum_amount_of_gadai_infinite_in_rupiah"
                    )}
                    error={errors.minimum_amount_of_gadai_infinite_in_rupiah}
                  />
                </div>
                <Description text="Nasabah yang melakukan transaksi minimal x rupiah atau lebih, termasuk gadai infinite dan dapat memilih agen saat transaksi." />
              </div>
            </div>
            <div style={{ flex: 0.2 }} />
            <div style={styles.container}>
              <div style={styles.title}>
                Maksimal Waktu sebagai Nasabah Infinite
              </div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="Hari"
                    value={data.customer_infinite_duration_in_x_days}
                    onValueChange={handleChange(
                      "customer_infinite_duration_in_x_days"
                    )}
                    error={errors.customer_infinite_duration_in_x_days}
                  />
                </div>
                <Description text="Nasabah akan menjadi nasabah infinite dalam waktu x hari." />
              </div>
            </div>
          </div>

          <div className="d-flex mt-3">
            <div style={styles.container}>
              <div style={styles.title}>Komisi Pinjaman Referral</div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="%"
                    value={data.referral_code_commission_in_percent}
                    onValueChange={handleChange(
                      "referral_code_commission_in_percent"
                    )}
                    error={errors.referral_code_commission_in_percent}
                  />
                </div>
                <Description text="Pemilik referral akan menerima komisi sebesar x (%) dikalikan jumlah sewa modal." />
              </div>

              <Divider dashed className="detail-divider" />
              <div style={styles.title}>
                Komisi Pinjaman Referral Jika Tanpa Bunga
              </div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="%"
                    value={
                      data.referral_code_zero_capital_commission_value_in_percent
                    }
                    onValueChange={handleChange(
                      "referral_code_zero_capital_commission_value_in_percent"
                    )}
                    error={
                      errors.referral_code_zero_capital_commission_value_in_percent
                    }
                  />
                </div>
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Maksimal</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="Rupiah"
                    value={
                      data.referral_code_zero_capital_commission_max_in_rupiah
                    }
                    onValueChange={handleChange(
                      "referral_code_zero_capital_commission_max_in_rupiah"
                    )}
                    error={
                      errors.referral_code_zero_capital_commission_max_in_rupiah
                    }
                  />
                </div>
              </div>
              <Description
                text="Jika tidak ada bunga, maka komisi didapat adalah x (%) dikalikan pinjaman pokok."
                className="mt-2"
              />
            </div>
            <div style={{ flex: 0.2 }} />
            <div style={styles.container}>
              <div style={styles.title}>Komisi Perpanjangan Referral</div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="%"
                    value={data.referral_code_extension_commission_in_percent}
                    onValueChange={handleChange(
                      "referral_code_extension_commission_in_percent"
                    )}
                    error={errors.referral_code_extension_commission_in_percent}
                  />
                </div>
                <Description text="Pemilik referral akan menerima komisi sebesar x (%) dikalikan jumlah sewa modal." />
              </div>

              <Divider dashed className="detail-divider" />
              <div style={styles.title}>
                Komisi Perpanjangan Referral Jika Tanpa Bunga
              </div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="%"
                    value={
                      data.referral_code_extension_zero_capital_commission_value_in_percent
                    }
                    onValueChange={handleChange(
                      "referral_code_extension_zero_capital_commission_value_in_percent"
                    )}
                    error={
                      errors.referral_code_extension_zero_capital_commission_value_in_percent
                    }
                  />
                </div>
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Maksimal</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="Rupiah"
                    value={
                      data.referral_code_extension_zero_capital_commission_max_in_rupiah
                    }
                    onValueChange={handleChange(
                      "referral_code_extension_zero_capital_commission_max_in_rupiah"
                    )}
                    error={
                      errors.referral_code_extension_zero_capital_commission_max_in_rupiah
                    }
                  />
                </div>
              </div>
              <Description
                text="Jika tidak ada bunga, maka komisi didapat adalah x (%) dikalikan pinjaman pokok."
                className="mt-2"
              />
            </div>
          </div>

          <div className="d-flex mt-3">
            <div style={styles.container}>
              <div style={styles.title}>Komisi Pinjaman Agen</div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="%"
                    value={data.agent_commission_in_percent}
                    onValueChange={handleChange("agent_commission_in_percent")}
                    error={errors.agent_commission_in_percent}
                  />
                </div>
                <Description text="Agen akan menerima komisi sebesar x (%) dikalikan jumlah sewa modal." />
              </div>
              <Divider dashed className="detail-divider" />
              <div style={styles.title}>
                Komisi Pinjaman Agen Jika Tanpa Bunga
              </div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="%"
                    value={data.agent_zero_capital_commission_value_in_percent}
                    onValueChange={handleChange(
                      "agent_zero_capital_commission_value_in_percent"
                    )}
                    error={
                      errors.agent_zero_capital_commission_value_in_percent
                    }
                  />
                </div>
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Maksimal</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="Rupiah"
                    value={data.agent_zero_capital_commission_max_in_rupiah}
                    onValueChange={handleChange(
                      "agent_zero_capital_commission_max_in_rupiah"
                    )}
                    error={errors.agent_zero_capital_commission_max_in_rupiah}
                  />
                </div>
              </div>
              <Description
                text="Jika tidak ada bunga, maka komisi didapat adalah x (%) dikalikan pinjaman pokok."
                className="mt-2"
              />
            </div>
            <div style={{ flex: 0.2 }} />
            <div style={styles.container}>
              <div style={styles.title}>Komisi Perpanjangan Agen</div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="%"
                    value={data.agent_extension_commission_in_percent}
                    onValueChange={handleChange(
                      "agent_extension_commission_in_percent"
                    )}
                    error={errors.agent_extension_commission_in_percent}
                  />
                </div>
                <Description text="Agen akan menerima komisi sebesar x (%) dikalikan jumlah sewa modal." />
              </div>
              <Divider dashed className="detail-divider" />
              <div style={styles.title}>
                Komisi Perpanjangan Agen Jika Tanpa Bunga
              </div>
              <div className="d-flex mt-3">
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Value</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="%"
                    value={
                      data.agent_extension_zero_capital_commission_value_in_percent
                    }
                    onValueChange={handleChange(
                      "agent_extension_zero_capital_commission_value_in_percent"
                    )}
                    error={
                      errors.agent_extension_zero_capital_commission_value_in_percent
                    }
                  />
                </div>
                <div className="pr-2" style={styles.subContainer}>
                  <div className="mb-2 color-A6A6A6 small">Maksimal</div>
                  <FormNumber
                    style={styles.formNumber}
                    suffix="Rupiah"
                    value={
                      data.agent_extension_zero_capital_commission_max_in_rupiah
                    }
                    onValueChange={handleChange(
                      "agent_extension_zero_capital_commission_max_in_rupiah"
                    )}
                    error={
                      errors.agent_extension_zero_capital_commission_max_in_rupiah
                    }
                  />
                </div>
              </div>
              <Description
                text="Jika tidak ada bunga, maka komisi didapat adalah x (%) dikalikan pinjaman pokok."
                className="mt-2"
              />
            </div>
          </div>
          {/* //===== */}
        </div>
        <CanAccess
          role={AuthorizationList.update_customer_membership_settings}
          yes={
            <div className="ml-auto d-flex align-items-center justify-content-end mt-3">
              <Button
                disabled={submitting}
                loading={submitting}
                variant="primary"
                className="btn-action btn-add"
                style={{ width: 180, height: 36, margin: 5, borderRadius: 6 }}
                onClick={onSubmit}
              >
                Simpan
              </Button>
            </div>
          }
        />
      </div>
    </div>
  );
}

const styles = {
  container: {
    boxShadow: "0px 4px 12px rgba(54, 53, 53, 0.12)",
    flex: 5,
    padding: 12,
    borderRadius: 10,
  },
  subContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  title: {
    fontWeight: "600",
    fontSize: 14,
    color: " #2C465C",
  },
  formNumber: {
    height: 36,
    border: "0.75px solid #DCDCDC",
    width: "100%",
    paddingLeft: 6,
    borderRadius: 6,
    borderColor: "#DCDCDC",
  },
};
